import React from "react";
import LegendCantFind from "./LegendCantFind.jsx"

const VolumePricing = ({ volumePricing, isFixed, isSingleType,floatingTitle,filteredNumber,templateText,customizationModels,showSearched }) => {
  const cleanTitle = (title) => {
    return title
      .replace('36" ', "")
      .replace('48" ', "")
      .replace(" Roll-Up Sign", "")
      .replace("Standard ", "")
      .replace("Large ", "")
      .replace(" Finish", "")
      .replace("Velcro Overlay for ", "");
  };
  const formatMoney = (number, decPlaces, decSep, thouSep) => {
    (decPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces),
      (decSep = typeof decSep === "undefined" ? "." : decSep);
    thouSep = typeof thouSep === "undefined" ? "," : thouSep;
    var sign = number < 0 ? "-" : "";
    var i = String(
      parseInt((number = Math.abs(Number(number) || 0).toFixed(decPlaces)))
    );
    var j = (j = i.length) > 3 ? j % 3 : 0;

    return (
      sign +
      (j ? i.substr(0, j) + thouSep : "") +
      i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
      (decPlaces
        ? decSep +
          Math.abs(number - i)
            .toFixed(decPlaces)
            .slice(2)
        : "")
    );
  };

  const fixedTable = isFixed ? " fixed" : "";
  var prodGroupOrder = [];
  return (
    <>
    <div className={`legend-price-grid col-xs-12 legendHeader price-grid  ${fixedTable}`} >
      {volumePricing.map((pgp) => {
        if (prodGroupOrder.indexOf(pgp.ProductGroupID) === -1)
          prodGroupOrder.push(pgp.ProductGroupID);
        var saleWords = "";
        var onSalePGP = false;
        if (pgp.SalePrice !== 0 && pgp.SalePrice < pgp.Prices[0].PricePerUnit) {
          saleWords =
            "On Sale - Save " +
            Math.floor((1 - pgp.SalePrice / pgp.Prices[0].PricePerUnit) * 100) +
            "% regardless of quantity";
          onSalePGP = true;
        }
        var onSaleClass = onSalePGP ? " onSale" : "";
        return (
          <div
            className={
              isSingleType
                ? "col-xs-12 col-md-8"
                : "" + "col-xs-6 col-md-5  legend-price-grid-outer"
            }
            key={pgp.ProductGroupID}
          >
            <div className="row signTypeHeader visible-xs visible-sm">
              {isSingleType ? "" : cleanTitle(pgp.ProductGroupTitle)}
            </div>
            <div className={"legend-price-grid double" + onSaleClass}>
              {pgp.Prices.map((pr) => {
                var qtyString =
                  pr.FromQuantity +
                  (pr.ToQuantity === 0 ? "+" : " - " + pr.ToQuantity);
                var onSale =
                  pgp.SalePrice !== 0 && pgp.SalePrice < pr.PricePerUnit;
                var priceString = "$" + formatMoney(pr.PricePerUnit);
                var leftBorderClass = pr === pgp.Prices[0] ? "" : " leftBorder";
                return (
                  <div
                    className={
                      "col-xs-4 col-md-4 priceHeaderBox" +
                      leftBorderClass +
                      onSaleClass
                    }
                    key={pgp.ProductGroupID + "-" + pr.FromQuantity}
                  >
                    <div className="row bottomBorder priceQty">
                      <span className="hidden-sm hidden-xs">Quantity</span>
                      <span className="hidden-md hidden-lg">Qty</span>{" "}
                      {qtyString}
                    </div>
                    <div className="row">
                      {priceString}
                      {onSale && (
                        <img
                          className="salePriceSlash salePriceSlashLegendSearch"
                          src={cdnBase + "/images/redslash-volumeprice.png"}
                        />
                      )}
                      {onSale && (
                        <div className="orangePrice">
                          {"$" + formatMoney(pgp.SalePrice)}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
            {saleWords !== "" && (
              <div className="col-xs-12 priceHeaderBox saleText">
                {saleWords}
              </div>
            )}
          </div>
        );
      })}

    {filteredNumber <= 0 && showSearched && !isFixed && (
          <LegendCantFind
            customizationModels={customizationModels}
            templateText={templateText}
          />
        )}

      {!isSingleType && (
        <div className="double">
          <div className="col-xs-12 legendHeader header no-pad-992">
            <div className="legend-product-type">
             <div className="col-sm-12 col-md-2 legendsHeaderBox">{isFixed? floatingTitle:''}</div>
              <div className="col-sm-6 col-md-5 hidden-xs hidden-sm legend-price-grid-outer signTypeHeader">
                Non-Reflective
              </div>
              <div className="col-sm-6 col-md-5 hidden-xs hidden-sm legend-price-grid-outer signTypeHeader">
                Reflective
              </div>
            </div>
          </div>
        </div>
      )}
      
    </div>
    </>
  );
};

export default VolumePricing;
